import ManualThreeCardOracle from '../../components/oracle/ManualThreeCardOracle';

const ManualThreeCardOracleSpreadPage = ({lang = 'es'}) => {

  return (
    <div className="bg-gray-900 min-h-screen pt-16">
      <ManualThreeCardOracle lang={lang} />
    </div>
  );
};

export default ManualThreeCardOracleSpreadPage;